module.exports = __webpack_public_path__ + "static/img/1_1_1.25c92015.png";